import { apiGet, apiPost, apiPut } from '../../framework/client';
import { ERROR_API_CALL_FAILED } from '../../../common/framework/constants';
import { SplitPurchaseInvoiceRowReq } from '../../../common/application/model/api/SplitPurchaseInvoiceRowReq';
import { SplitPurchaseInvoiceRowResp } from '../../../common/application/model/api/SplitPurchaseInvoiceRowResp';
import { Finvoice } from '../../../common/application/model/integration/finvoice/Finvoice';
import { NetvisorAttachmentMeta } from '../../../common/application/model/integration/netvisor/NetvisorAttachmentMeta';
import { VehicleContractPurchaseInvoice } from '../../../common/application/model/report/VehicleContractPurchaseInvoice';
import { RegistrationNumberMatch } from '../../../common/application/model/integration/finvoice/RegistrationNumberMatch';
import { RowRegNumberContracts } from '../../../common/application/model/api/RowRegNumberContracts';
import { UpdateAllInvoiceRowsTypeReq } from '../../../common/application/model/api/UpdateAllInvoiceRowsTypeReq';
import { PurchaseInvoiceRow } from '../../../common/application/model/PurchaseInvoiceRow';

export async function postSplitPurchaseInvoiceRowRequest(
    splitPurchaseInvoiceRowReq: SplitPurchaseInvoiceRowReq,
): Promise<SplitPurchaseInvoiceRowResp> {
    const response = await apiPost('/api/purchase-invoice-row/split', splitPurchaseInvoiceRowReq);
    if (response.status === 200) {
        return (await response.json()) as SplitPurchaseInvoiceRowResp;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function putUpdateAllInvoiceRowsTypeReq(
    updateAllInvoiceRowsTypeReq: UpdateAllInvoiceRowsTypeReq,
): Promise<Response> {
    const response = await apiPut('/api/purchase-invoice/update-all-invoice-rows-type', updateAllInvoiceRowsTypeReq);
    if (response.status === 200) {
        return (await response.json());
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function getFinvoiceByInvoiceId(
    purchaseInvoiceId: string,
): Promise<{ finvoice: Finvoice; registrationNumbers: RegistrationNumberMatch[] }> {
    const response = await apiGet(`/api/admin/purchaseinvoice/finvoice/${purchaseInvoiceId}`);
    if (response.status === 200) {
        return (await response.json()) as { finvoice: Finvoice; registrationNumbers: RegistrationNumberMatch[] };
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function getFinvoiceRowSuggestionsByInvoiceId(
    purchaseInvoiceId: string,
    rowNumbers: number[],
): Promise<RowRegNumberContracts> {
    const queryParams = { purchaseInvoiceId, rowNumbers };
    const response = await apiGet(`/api/admin/purchase-invoice-rows/finvoice`, queryParams);
    if (response.status === 200) {
        return (await response.json()) as RowRegNumberContracts;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function getNetvisorPurchaseInvoiceAttachments(
    purchaseInvoiceId: string,
): Promise<NetvisorAttachmentMeta[]> {
    const response = await apiGet(`/api/user/netvisor/purchaseinvoice/${purchaseInvoiceId}/attachments`);
    if (response.status === 200) {
        return await response.json();
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function getVehicleContractPurchaseInvoices(
    vehicleContractId: string,
): Promise<VehicleContractPurchaseInvoice[]> {
    const response = await apiGet(`/api/manager/purchaseinvoice/${vehicleContractId}`);
    if (response.status === 200) {
        return await response.json();
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function getInvoiceRowsTotalPrice(
    purchaseInvoiceId: string,
): Promise<any> {
    const response = await apiGet(`/api/purchase-invoice/invoice-rows-total-price/${purchaseInvoiceId}`);
    if (response.status === 200) {
        return await response.json();
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function updatePurchaseInvoiceRow(
    purchaseInvoiceRow: PurchaseInvoiceRow,
): Promise<PurchaseInvoiceRow> {
    const response = await apiPut(`/api/purchase-invoice/update-purchase-invoice-row`, purchaseInvoiceRow);
    if (response.status === 200) {
        return await response.json();
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function addPurchaseInvoiceRow(
    purchaseInvoiceRow: PurchaseInvoiceRow,
): Promise<PurchaseInvoiceRow> {
    const response = await apiPost(`/api/purchase-invoice/add-purchase-invoice-row`, purchaseInvoiceRow);
    if (response.status === 200) {
        return await response.json();
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}